<template>
  <div
    :class="{
      [$style.progressBarComponent]: true,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
  >
    <div
      :class="{
        [$style.progress]: true,
        [$style.progressNewDesign]: isNewDesign
      }"
      :style="{ width: width }"
    ></div>
    <div
      :class="{ [$style.bar]: true, [$style.barNewDesign]: isNewDesign }"
    ></div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  computed: {
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    el() {
      return store.state.el
    },
    numOfSlides() {
      return store.getters['numOfSlides']
    },
    currentSlide() {
      return store.state.currentSlide
    },
    slide() {
      return store.getters['slide']
    },
    width() {
      // note: num of slides - 1 because last one doesn't count
      return ((this.currentSlide + 1) / this.numOfSlides) * 100 + '%'
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.progressBarComponent {
  position: relative;
  margin: 0 auto;
  display: flex;
  // width: 91.67%;
  // padding-top: 41px;
  padding-top: 41px;
  // padding-top: 2.88%;
  // padding-bottom: 73px;
}

.bar {
  position: absolute;
  top: 41px;
  height: 2px;
  background-color: $color_grey_1;
  width: 100%;
}

// note: new design
.barNewDesign {
  background-color: $color_progress_back_new;
}

.progress {
  top: 39px;
  position: absolute;
  z-index: 10;
  height: 6px;
  background-color: $color_green_2;
  border-radius: 4px;
}

// note: new design
.progressNewDesign {
  background-color: $color_progress_new;
}
</style>
